/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ConfirmMeChangeEmailRequestFromJSON(json) {
    return ConfirmMeChangeEmailRequestFromJSONTyped(json, false);
}
export function ConfirmMeChangeEmailRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        token: !exists(json, 'token') ? undefined : json['token']
    };
}
export function ConfirmMeChangeEmailRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        token: value.token
    };
}
